import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { discountEditorSelectors } from 'redux/modules/DiscountEditor';
import { closeButtonClick, hideAlert } from 'redux/modules/Alert/alert';
import { PopupConfirm } from 'view/molecules/PopupConfirm';
import { DiscountEditorExitModalProps } from './DiscountEditorExitModal.model';

export const DiscountEditorExitModal = ({
  isShown,
  closeHandler,
  confirmHandler,
}: DiscountEditorExitModalProps) => {
  const { t } = useTranslation();
  const warning = useAppSelector(discountEditorSelectors.getWarning);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  const closePopUpHandler = () => {
    navigate(pathname);
    if (warning?.existingDiscountID) {
      dispatch(hideAlert());
      dispatch(closeButtonClick());
    }
    closeHandler();
  };

  return isShown ? (
    <PopupConfirm
      closeHandler={closePopUpHandler}
      confirmHandler={confirmHandler}
      title={t('discountLeavingPopup.title')}
      description={t('discountLeavingPopup.description')}
      yesText={t('discountLeavingPopup.confirm')}
      cancelText={t('other.cancel')}
    />
  ) : null;
};
